import React, { Component } from 'react'
import _ from 'lodash'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { RepublicanDate } from '../../../../../../../helpers/date/republicanDate'
import { toRoman } from 'roman-numerals'
import {
    invalidDateParts,
    missingDateParts,
} from '../../../../../../../helpers/collaborativeIndexations'
import Select from '../../../../Forms/Commons/Select'

class Republican extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        resetInvalidField: PropTypes.func.isRequired,
        isInvalidField: PropTypes.func.isRequired,
        updateFieldValue: PropTypes.func.isRequired,
        fields: PropTypes.object.isRequired,
        fieldName: PropTypes.string.isRequired,
    }

    constructor(props)
    {
        super(props)

        this.updateDate = this.updateDate.bind(this)
        this.retrieveDatePartValue = this.retrieveDatePartValue.bind(this)
        this.formattedDatePartValue = this.formattedDatePartValue.bind(this)
        this.isDatePartValid = this.isDatePartValid.bind(this)
        this.months = this.months.bind(this)
        this.years = this.years.bind(this)
        this.handleDayFieldFocus = this.handleDayFieldFocus.bind(this)
        this.handleDayFieldBlur = this.handleDayFieldBlur.bind(this)
        this.updateDayField = this.updateDayField.bind(this)

        this.day = React.createRef()
        this.month = React.createRef()
        this.year = React.createRef()
        this.monthSelectComponent = React.createRef()

        this.state = {
            isFocusOnDayField: false,
        }
    }

    updateDayField()
    {
        this.updateDate(this.day, this.day.current.value)

        if(this.day.current.value.toString().length > 1)
        {
            this.monthSelectComponent.current.focus()
        }
    }

    updateDate(fieldRef, value)
    {
        fieldRef.current.value = value

        const { fieldName } = this.props
        this.props.resetInvalidField(fieldName)

        this.props.updateFieldValue(fieldName, {
            year: this.year.current.value,
            month: this.month.current.value,
            day: this.day.current.value,
        })
    }

    retrieveDatePartValue(datePart)
    {
        const { fields, fieldName } = this.props

        if(! fields[fieldName])
        {
            return null
        }

        const datePartValue = fields[fieldName]['parts'][datePart]

        if(! Number.isInteger(datePartValue))
        {
            return null
        }

        return datePartValue
    }

    formattedDatePartValue(datePart)
    {
        const datePartValue = this.retrieveDatePartValue(datePart)

        if(datePartValue === null)
        {
            return ''
        }

        if(datePart === 'day' && ! this.state.isFocusOnDayField)
        {
            return _.padStart(datePartValue, 2, 0)
        }

        return datePartValue
    }

    isDatePartValid(datePart)
    {
        const { fieldName } = this.props

        if(! this.props.isInvalidField(fieldName))
        {
            return true
        }

        const invalidParts = invalidDateParts(this.props.fields[fieldName])

        return _.indexOf(invalidParts, datePart) === -1
    }

    months()
    {
        return RepublicanDate.MONTHS.map((month, index) => (
            { value: index + 1, label: this.props.t(`visualizer:toolbar.left.collaborativeIndexationCreation.republicanForm.dropdownMonths.${month}`)}
        ))
    }

    years()
    {
        return _.range(1, RepublicanDate.MAX_YEARS + 1).map(year => ({value: year, label: toRoman(year)}))
    }

    handleDayFieldFocus()
    {
        this.setState({isFocusOnDayField: true})
        this.day.current.select()
    }

    handleDayFieldBlur()
    {
        this.setState({isFocusOnDayField: false})
    }

    render()
    {
        const { t, fields, fieldName } = this.props

        return (
            <React.Fragment>
                <div className={'republican'}>
                    <input
                        type={'number'}
                        ref={this.day}
                        className={classNames('day', {'error': ! this.isDatePartValid('day')})}
                        value={this.formattedDatePartValue('day')}
                        onFocus={this.handleDayFieldFocus}
                        onBlur={this.handleDayFieldBlur}
                        onChange={() => this.updateDayField()}
                        title={t('visualizer:toolbar.left.collaborativeIndexationCreation.gregorianForm.day.label')}
                        placeholder={t('visualizer:toolbar.left.collaborativeIndexationCreation.gregorianForm.day.placeholder')}
                    />
                    <Select
                        forwardedRef={this.monthSelectComponent}
                        options={[
                            {value: '', label: t('visualizer:toolbar.left.collaborativeIndexationCreation.republicanForm.month')},
                            ...this.months(),
                        ]}
                        value={this.formattedDatePartValue('month')}
                        className={classNames('month', {'error': ! this.isDatePartValid('month')})}
                        onChange={option => this.updateDate(this.month, option.value)}
                        isSearchable={true}
                    />
                    <input type={"hidden"} ref={this.month} value={this.formattedDatePartValue('month')}/>
                    <Select
                        options={[
                            {value: '', label: t('visualizer:toolbar.left.collaborativeIndexationCreation.republicanForm.year')},
                            ...this.years(),
                        ]}
                        className={classNames('year', {'error': ! this.isDatePartValid('year')})}
                        value={this.formattedDatePartValue('year')}
                        onChange={option => this.updateDate(this.year, option.value)}
                        isSearchable={true}
                    />
                    <input type={"hidden"} ref={this.year} value={this.formattedDatePartValue('year')}/>
                </div>
                {this.props.isInvalidField(fieldName) && missingDateParts(fields[fieldName]).length > 0 &&
                <div className='format-error'>{t('visualizer:toolbar.left.collaborativeIndexationCreation.republicanForm.formatError')}</div>}
            </React.Fragment>
        )
    }
}

export default withTranslation()(Republican)
